<template>
  <div id="app">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>

    <router-view v-if="!$route.meta.keepAlive"></router-view>

  </div>
</template>
<style>
@import './assets/css/normalize.css';
@import './assets/css/main.css';
</style>
<script>
export default {
  name: 'reservation',
  created() {
    this.getUserInfo()
    this.initCart()
  },
  methods: {
    // 用jsBridge获取userInfo
    getUserInfo() {
      this.JsBridge.callHandler(
        'getUserInfo', //原生声明的函数名称
        { data: 'getUserInfo' }, //发送给原生的数据
        res => {
          const resJson = JSON.parse(res)
          this.$store.commit('updateUserId', resJson.userId)
          this.$store.commit('updateCommunicationToken', resJson.communicationToken)
          console.log(this.$store.state.userId)
          console.log(this.$store.state.communicationToken)
        }
      )
    },
    initCart() {
      this.JsBridge.registerHandler('willAppear', res => {
        console.log('willAppear')
        this.$store.commit('initCart')
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/App.vue